import axios from 'axios';

class StatsInfo {
  constructor(element) {
    this.blockElement = element;
    this.apiUrl = this.blockElement.dataset.api || null;
    this.donationsValue = this.blockElement.querySelector(
      '.stats-block__donations-value'
    );
    this.registrationCount = this.blockElement.querySelector(
      '.stats-block__registrations-count'
    );
    this.ngos = this.blockElement.querySelector('.stats-block__ngos');
    this.donationsCount = this.blockElement.querySelector(
      '.stats-block__donations-count'
    );
  }

  init() {
    if (
      !this.apiUrl ||
      !this.donationsValue ||
      !this.registrationCount ||
      !this.ngos ||
      !this.donationsCount
    ) {
      console.error(
        'Brak atrybutu data-api lub elementu <span> w bloku.',
        this.blockElement
      );
      return;
    }

    this.fetchData();
  }

  async fetchData() {
    try {
      const response = await axios.get(this.apiUrl);

      if (response.data && response.data.totalDonationsValue !== undefined) {
        const count = response.data.totalDonationsValue;
        const formattedCount = new Intl.NumberFormat('pl-PL').format(count);

        this.donationsValue.textContent = formattedCount;
      } else {
        console.warn(
          `Nie znaleziono "totalDonationsValue" w odpowiedzi z API: ${this.apiUrl}`
        );
      }

      if (response.data && response.data.registrationsCount !== undefined) {
        const count = response.data.registrationsCount;
        const formattedCount = new Intl.NumberFormat('pl-PL').format(count);

        this.donationsCount.textContent = formattedCount;
      } else {
        console.warn(
          `Nie znaleziono "registrationsCount" w odpowiedzi z API: ${this.apiUrl}`
        );
      }

      if (response.data && response.data.ngosCount !== undefined) {
        const count = response.data.ngosCount;
        const formattedCount = new Intl.NumberFormat('pl-PL').format(count);

        this.ngos.textContent = formattedCount;
      } else {
        console.warn(
          `Nie znaleziono "ngosCount" w odpowiedzi z API: ${this.apiUrl}`
        );
      }

      if (response.data && response.data.donationsCount !== undefined) {
        const count = response.data.donationsCount;
        const formattedCount = new Intl.NumberFormat('pl-PL').format(count);

        this.registrationCount.textContent = formattedCount;
      } else {
        console.warn(
          `Nie znaleziono "donationsCount" w odpowiedzi z API: ${this.apiUrl}`
        );
      }
    } catch (error) {
      console.error(
        `Błąd podczas pobierania danych z ${this.apiUrl}:`,
        error.message
      );
      this.donationsValue.textContent = '0';
      this.registrationCount.textContent = '0';
      this.ngos.textContent = '0';
      this.donationsCount.textContent = '0';
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.stats-block').forEach((blockElement) => {
    const instance = new StatsInfo(blockElement);

    instance.init();
  });
});
